import React from 'react';
import { hasUnsyncedAtPath } from './quoteSnapshotUtils';

function SavedCheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-check"
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

export default function QuoteField({
  fieldId,
  focusedField,
  unsynced,
  savedFields,
  setFocusedField,
  className,
  children,
}) {
  const isSaving = hasUnsyncedAtPath(unsynced, fieldId) && focusedField !== fieldId;
  const isSaved = savedFields?.includes(fieldId);

  const child = React.Children.only(children);
  const { onFocus: childOnFocus, ...childProps } = child.props;
  const tag = child.type;
  const isFocusable =
    tag === 'input' || tag === 'textarea' || tag === 'select';

  const fieldControl = isFocusable
    ? React.cloneElement(child, {
        ...childProps,
        onFocus: (e) => {
          setFocusedField(fieldId);
          if (childOnFocus) childOnFocus(e);
        },
      })
    : child;

  return (
    <div className={`quote-field-wrap${className ? ` ${className}` : ''}`}>
      {isSaving && <div className="saving-flash" aria-hidden="true" />}
      {fieldControl}
      <div className={`saved-indicator${isSaved ? ' shown' : ''}`} aria-hidden="true">
        <SavedCheckIcon />
      </div>
    </div>
  );
}
